import { ShoeSneakerIcon } from './ShoeSneakerIcon';

/**
 * author: Michael Irigoyen
 * id EA78AFA5-70F2-4878-A1D5-746B410E1DA0
 * name shoe-sneaker
 * version: 5.6.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shoe-sneaker.svg
 * tags
 * - Sport 
 * - Clothing 
 */
export const ShoeRunningIcon = ShoeSneakerIcon;
export default ShoeRunningIcon